import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom'
import "./Header.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";

// buffer
import BizCards from "../components/buffers/BizCards";
import Stickers from "../components/buffers/Stickers";
import QrCodes from "../components/buffers/QrCodes";
import Labels from "../components/buffers/Labels";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Header({ currentLocale }) {
  const query = useQuery()

  const [bufferType, setBufferType] = useState("qr-codes");
  
  useEffect(() => {
    const bufferType = query.get("type")
    switch (bufferType) {
      case 'biz-cards':
        setBufferType("biz-cards")
        break
      case 'stickers':
        setBufferType("stickers")
        break
      case 'labels':
        setBufferType("labels")
        break
      case 'qr-codes':
        setBufferType("qr-codes")
        break
      default:
        break
    }
  },[]);

  return (
    <>
      <h1 id="heading">
        <FormattedMessage id="home.heading" />
      </h1>
      <section id="template-types">
        <div className="coming-soon"><span><FormattedMessage id="home.comingsoon" /></span></div>
        <div
          onClick={() => setBufferType("biz-cards")}
          className={`type ${bufferType === "biz-cards" && "selected"}`}
        >
          <p>
            <FormattedMessage id="home.types.bizcards" />
          </p>
        </div>
        <div
          onClick={() => setBufferType("stickers")}
          className={`type ${bufferType === "stickers" && "selected"}`}
        >
          <p>
            <FormattedMessage id="home.types.stickers" />
          </p>
        </div>
        <div
          onClick={() => setBufferType("labels")}
          className={`type ${bufferType === "labels" && "selected"}`}
        >
          <p>
            <FormattedMessage id="home.types.labels" />
          </p>
        </div>
        <div
          onClick={() => setBufferType("qr-codes")}
          className={`type ${bufferType === "qr-codes" && "selected"}`}
        >
          <p>
            <FormattedMessage id="home.types.qrcodes" />
          </p>
        </div>
      </section>
      <div id="templates-container">
        <div className={`slider`}>
          {bufferType === "biz-cards" && (
            <>
              <BizCards currentLocale={currentLocale} />
            </>
          )}
          {bufferType === "stickers" && (
            <>
              <Stickers currentLocale={currentLocale} />
            </>
          )}
          {bufferType === "labels" && (
            <>
              <Labels currentLocale={currentLocale} />
            </>
          )}
          {bufferType === "qr-codes" && (
            <>
              <QrCodes currentLocale={currentLocale} />
            </>
          )}
        </div>
      </div>
      <div id="scroll-down">
        <div className="scroll-label"><FormattedMessage id="header.scrollText" /></div>
        <div className="scroll-icon-container">
          <img className='scroll-icon scroll-icon--sm' src="lib/images/icon-down-sm.svg" alt="" />
          <img className='scroll-icon scroll-icon--lg' src="lib/images/icon-down-lg.svg" alt="" />
        </div>
      </div>
    </>
  );
}

export default Header;
